export default __webpack_public_path__ + "static/media/illustration-login.93bcd06f.svg";